(function () {
  'use strict';

  function distributionOptions (moment) {
    return {
      'restrict': 'E',
      'templateUrl': 'components/where-to/distribution-options/distribution-options.html'
    };
  }

  angular.module('web2print.whereTo')
    .directive('distributionOptions', distributionOptions);

  distributionOptions.$inject = [ 'moment' ];
})();
